import { Guid } from "../../types/guid.type";

export interface IIdentityProfilDataRequestInfo {
  IdentityUid?: Guid;
  Email?: string;
  TenantAppUid?: Guid;
  Environment?: string;
}

export class IdentityProfilDataRequest {
  IdentityUid?: Guid;
  Email?: string;
  TenantAppUid?: Guid;
  Environment?: string;

  constructor(info: IIdentityProfilDataRequestInfo) {
    this.IdentityUid = info.IdentityUid;
    this.Email = info.Email;
    this.TenantAppUid = info.TenantAppUid;
    this.Environment = info.Environment;
  }

  static createInstance(info: IIdentityProfilDataRequestInfo): IdentityProfilDataRequest {
    return new IdentityProfilDataRequest(info);
  }
}
